// extracted by mini-css-extract-plugin
export default {"description-cell":"IaJK7g","descriptionCell":"IaJK7g","header":"VCNp09"};